export default function filters() {
    // Collection Filters
    let filterButtons = document.querySelectorAll('.filters__dropdown .sort-by')

    // toggle the filter dropdowns
    filterButtons.forEach(function (el, index) {
        el.addEventListener('click', function () {
            el.classList.toggle('open')
        })
    })
}
